"use client";
import { useEffect, useState } from "react";
import { SignIn } from ".";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import { ToastContainer, toast } from "react-toastify";
import { SignUp } from "../SignUp";
// import { resetarSenha } from "../../../../actions/assistamais/api";
import { useHistory } from "react-router-dom";
import { useToastify } from "app/hooks/useToastify";

interface passwordProps {
  token: string;
  resetPasword: any
}

export default function Index({ token, resetPasword }: passwordProps) {
  const history = useHistory();
  const [isLoading, setIsLoading] = useState(false);
  const [step, setStep] = useState(1);
  const [showPassword, setShowPassword] = useState(false);

  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const [isFormValid, setIsFormValid] = useState(false);
  const [code, setCode] = useState([]);
  const [codeValidated, setCodeValidated] = useState(false);
  const [recoverInfo, setRecoverInfo] = useState("");
  const [validation, setValidation] = useState({
    isLengthValid: false,
    isUpperCaseValid: false,
    isLowerCaseValid: false,
    isNumberValid: false,
    isSpecialCharValid: false,
    isEqualPassword: false,
  });

  const toast = useToastify();

  const formValid = (password: string) => {
    const lengthValid = password.length >= 8;
    const upperCaseValid = /[A-Z]/.test(password);
    const lowerCaseValid = /[a-z]/.test(password);
    const numberValid = /\d/.test(password);
    const specialCharValid = /[!@#$%^&*]/.test(password);
    const equalPassword = password.length > 0 && password == confirmPassword;

    setValidation({
      isLengthValid: lengthValid,
      isUpperCaseValid: upperCaseValid,
      isLowerCaseValid: lowerCaseValid,
      isNumberValid: numberValid,
      isSpecialCharValid: specialCharValid,
      isEqualPassword: equalPassword,
    });

    const isFormInvalid = [
      lengthValid,
      upperCaseValid,
      lowerCaseValid,
      numberValid,
      specialCharValid,
      equalPassword,
    ].every(Boolean);

    setIsFormValid(isFormInvalid);

    return isFormInvalid
  };

  async function resetSenha() {

    if (!formValid(password)) {
      toast.show("warning", "Senha inválida. Siga as regras de senha para criar a sua.")
      return
    }

    try {
      setIsLoading(true);

      let response: any = await resetPasword({senha: password});

      if (response) {
        setStep(2);
      }
    } catch (error: any) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }

  }

  const validations = [
    {
      id: "validation-length",
      text: "8 caracteres",
      validation: validation.isLengthValid,
    },
    {
      id: "validation-upper",
      text: "1 letra maiúscula",
      validation: validation.isUpperCaseValid,
    },
    {
      id: "validation-lower",
      text: "1 letra minúscula",
      validation: validation.isLowerCaseValid,
    },
    {
      id: "validation-number",
      text: "1 número",
      validation: validation.isNumberValid,
    },
    {
      id: "validation-caracter",
      text: "1 caractere especial",
      validation: validation.isSpecialCharValid,
    },
    // { id: "validation-equal", text: "Senhas iguais", validation: validation.isEqualPassword }
  ];

  useEffect(() => {
    formValid(password);
    // savePassword(password);
  }, [password, confirmPassword]);

  useEffect(() => {
    if (code.length === 0) {
      setCodeValidated(false);
    }

    const allFieldsFilled = code.every(
      (value) => value !== "" && value !== undefined
    );

    if (!allFieldsFilled) {
      setCodeValidated(false);
    }

    if (allFieldsFilled && code.length == 6) {
      setCodeValidated(true);
      //   handleValidation();
    }
  }, [code]);

  const handleStep = () => {
    if (step == 1){
      resetSenha();
    } else
      history.replace('/session/signin');
  };

  const backHome = () => {
    history.replace('/session/signin');
  };

  const getButtonText = () => {
    if (step == 1) return "Confirmar";
    else return "Login";
  };

  return (
    <div className="tw-flex tw-flex-col tw-mx-auto tw-w-full tw-py-[80px] tw-px-[80px]">
      <div className="tw-border-[#151A25] tw-border tw-px-5 tw-py-10 tw-my-auto tw-h-full tw-max-h-[860px] tw-w-full tw-text-xl tw-bg-white tw-shadow-lg tw-rounded-[48px] max-lg:tw-px-[20px] tw-max-w-[596px] tw-mx-auto">
        <SignIn.Root
          className="tw-px-[20px] lg:tw-px-[32px] xl:tw-px-[60px] 2xl:tw-px-[80]px tw-gap-[80px]"
        >
          <div className="tw-self-start tw-flex tw-flex-col tw-w-full">
            {step == 1 && (
              <>
                <SignIn.Title className="tw-text-4xl" text={"Redefinir senha"} />
                {/* <SignIn.Subtitle
                  className="tw-font-medium tw-mt-8"
                  text={"Defina sua senha para acessar a Use Mais."}
                /> */}
                <SignIn.Input
                  type={showPassword ? "text" : "password"}
                  name="newPassword"
                  placeholder="Digite sua nova Senha"
                  className="tw-mt-8"
                  onChange={(e) => setPassword(e.target.value)}
                />
                <SignIn.Input
                  type={showPassword ? "text" : "password"}
                  name="newPasswordConfirm"
                  placeholder="Repita sua nova Senha"
                  onChange={(e) => setConfirmPassword(e.target.value)}
                />
                {/* <SignIn.Actions>
                            <SignIn.Action id="showPassword" onClick={() => setShowPassword(!showPassword)} icon={showPassword ? VisibilityOffIcon : VisibilityIcon} />
                        </SignIn.Actions> */}
                <SignUp.Validations>
                  <div className="tw-flex tw-flex-col tw-mt-4  tw-self-start tw-text-justify tw-password-text-tip">
                    <span className="text-lg">Sua senha deve ter:</span>
                    <div className="tw-flex tw-flex-col tw-mt-4 tw-gap-2 tw-self-start tw-ml-2 tw-text-justify tw-password-text-tip">
                      {validations.map((validation) => (
                        <SignUp.Validation
                          key={validation.id}
                          id={validation.id}
                          icon={CheckBoxIcon}
                          text={validation.text}
                          validation={validation.validation}
                        />
                      ))}
                    </div>
                  </div>
                </SignUp.Validations>
              </>
            )}

            {step == 2 && (
              <>
                <SignIn.Title text={"Senha redefinida com sucesso!"} />
              </>
            )}
          </div>
          <div className="tw-self-end tw-flex tw-flex-col tw-w-full">
            <SignIn.Action
              id="checkUser"
              onClick={handleStep}
              text={getButtonText()}
              className={`tw-self-end tw-mt-10 tw-items-center tw-text-center tw-p-2.5 tw-w-full tw-text-white tw-rounded-lg tw-shadow-sm ${
                !isLoading
                  ? "tw-bg-[linear-gradient(90deg,#E13441_0%,#FAAE2E_100%)]"
                  : "tw-bg-gray-400"
              }`}
              disabled={isLoading}
            />
            {step < 2 && (
              <SignIn.Action
                id="back"
                onClick={backHome}
                text="Voltar"
                className="tw-self-end tw-items-center tw-p-2.5 tw-mt-4 tw-text-center tw-w-full tw-text-red-400 tw-rounded-lg tw-border tw-border-red-400 tw-border-solid"
                disabled={isLoading}
              />
            )}
          </div>
        </SignIn.Root>
      </div>

      <ToastContainer
        theme="colored"
        position="top-right"
      />
    </div>
  );
}
